var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8337 3.99984C14.0271 4.00001 15 4.97353 15 6.16699V12.8337C14.9998 14.027 14.027 14.9998 12.8337 15H6.16699C4.97353 15 4.00001 14.0271 3.99984 12.8337V6.16699C3.99984 4.97342 4.97342 3.99984 6.16699 3.99984H12.8337ZM6.16699 5.6665C5.8939 5.6665 5.6665 5.8939 5.6665 6.16699V12.8337C5.66668 13.1066 5.894 13.3333 6.16699 13.3333H12.8337C13.1065 13.3332 13.3332 13.1065 13.3333 12.8337V6.16699C13.3333 5.894 13.1066 5.66668 12.8337 5.6665H6.16699Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83301 0C10.0265 0 11 0.972919 11.0002 2.16634C11.0002 2.62652 10.627 2.99959 10.1668 2.99967C9.70659 2.99967 9.3335 2.62658 9.3335 2.16634C9.33332 1.89339 9.106 1.66667 8.83301 1.66667H2.16634C1.8935 1.66685 1.66685 1.8935 1.66667 2.16634V8.83301C1.66667 9.106 1.89339 9.33332 2.16634 9.3335C2.62658 9.3335 2.99967 9.70659 2.99967 10.1668C2.99959 10.627 2.62652 11.0002 2.16634 11.0002C0.972919 11 0 10.0265 0 8.83301V2.16634C0.000176849 0.973028 0.973028 0.000176849 2.16634 0H8.83301Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconNew);
export default __webpack_public_path__ + "static/media/copy-icon-new.6e1e637da3b94fb1c56fa11e9a3d5a43.svg";
export { ForwardRef as ReactComponent };